import { Video } from "lucide-react";

export function Logo({ size = "md", onDark = true }) {
  const dims = size === "lg" ? "h-11 w-11" : size === "sm" ? "h-8 w-8" : "h-9 w-9";
  const text = size === "lg" ? "text-3xl" : size === "sm" ? "text-lg" : "text-2xl";
  return (
    <div className="flex items-center gap-2.5 select-none">
      <div className={`${dims} bg-primary flex items-center justify-center rounded-md shadow-[0_0_20px_rgba(255,59,48,0.35)]`}>
        <Video className="h-1/2 w-1/2 text-white" strokeWidth={2.75} />
      </div>
      <span className={`font-heading font-black uppercase tracking-tighter leading-none ${text} ${onDark ? "text-white" : "text-black"}`}>
        Coach<span className="text-primary">View</span>
      </span>
    </div>
  );
}
